module.exports = __webpack_public_path__ + "img/orion-svg-sprite.125fa575.svg";